export interface AuthData {
  user: string,
  password: string,
  device:string,
  browser:string,
  screenResolution:string,
  productoId?:string,
  opcion?:string,
}

export interface ResponseLogin{
  dataUser:{
    userId: string,
    user:string,
    empresaId: string,
    instituto: number,
    accessToken:string,
    expiresIn:string,
    empresaPadre?: string,
    tokenActualizacion?: string,
    fecha?:Date
  }
}
export interface RespuestaGen{
  success?: boolean,
  message?: string
}
export interface ResIdiGua{
  idiomasMostrar: any
}
export interface infoEmpresa{
  data:{
    institutoEmpresa: number,
    nombreEmpresa: string,
    nombrePublicacion: string,
    anioFundacion: number,
    empleadosCompleto: number,
    empleadosParcial: number,
    totalColaboradores: number,
    sector: number,
    subSector: number,
    multinacional: number,
    tipo: number,
    ranking: number,
    anioRanking: number,
    region: string,
    nombreResponsable: string,
    apellidoResponsable: string,
    emailResponsable: string,
    telResponsable: number,
    extResponsable: number,
    celResponsable: number,
    nombreRH: string,
    emailRH: string,
    telRH: number,
    extRH: number,
    celRH: number,
    nombreTI: string,
    emailTI: string,
    telTI: number,
    extTI: number,
    celTI: number,
    entregable: number,
    vivoEmpresa: number,
    imagen?: string,
    logoEmpresa:any
  }
}
export interface infoUsuarioResp{
  data: {
    user: string,
    level: number,
    empresaId: string,
    empresaPadre?: string,
    id_CT:string,
    productoId?:string,
    institutoId: number,
    leader_go:boolean,
    action_go:boolean,
  }
}
export interface infoUsuario{

  user: string,
  level: number,
  empresaId: string,
  empresaPadre?: string,
  institutoId: number,
  leader_go:boolean,
  action_go:boolean,

}
export interface getUsuarioEmpresa{
  success: boolean,
  usuario: {
    vivoUsuario: number,
    _id: string,
    user: string,
    password: string,
    level: number,
    empresaId: string,
    createdAt: string,
    updatedAt: string,
    __v: number
  }
}
///////////interfaces productos
export interface prodCert{
  idCertificar: string,
  idPlantilla?: string,
  fechaCertificar: number,
  completoCertificar: number,
  secciones?: seccionProducto[],
  tipo?:number,
  activo?:boolean,
  idSurvey?:number,
  tokenConfig?:string,
  nombreProducto?:any,
  idProducto:any;
  modalCambios?:boolean,
}
export interface prodMed{
  idMedir: string,
  idPlantilla?: string,
  fechaMedir: number,
  completoMedir: number,
  idSurvey?:number,
  tokenConfig:string;
}
export interface prodNorma35{
  idNorma35: string,
  idPlantilla?: string,
  fechaNorma35: number,
  completoNorma35: number,
  tipo: number,
  claveInabe?: string,
  claveVideo?: string,
  idSurveyMas?: number,
  idSurveyMenos?: number,
  tokenConfig?:string,
  modalCambios?:boolean,
  tokenMas50?: string,
  tokenMenos50?: string,
  correoPendiente?: boolean,

}
export interface prodPulseCheck{
  idPulseCheck: string,
  idPlantilla?: string,
  fechaLanzamiento:string,
  fechaPulseCheck: number,
  completoPulseCheck: number,
  idSurvey?:number,
  tokenConfig:string;
  numero:number;
}
export interface prodDocumentador{
  idDocumentador: string,
  fechaDocumentador: number,
  idProducto?:any;
}
export interface prodFocusArea{
  idFocusArea: string,
  idPlantilla?: string,
  fechaFocus: number,
  completoFocusArea: number,
  idSurvey?:number,
}
export interface prodCultureAudit{
  idCulture: string,
  fechaCulture: number,
  link?:string,
  tipo?:number,
  vivo?:number
}
export interface prodResultados{
  _id: string,
  fecha: number,
  surveyToken: string,
  activo?:boolean
}
export interface prodPaquete{
  _id: string,
  nombreProducto: string,
  fecha: number,
  tipo: number,
  productos?: any[]
}
export interface productosResultadosForallViejas{
  _id: string,
  nombreProducto: string,
  fecha: number,
  link: string
}

export interface productosResultados4all{
  _id: string,
  nombreProducto: string,
  fecha: number,
  link: string
}
export interface productosResultadosSencillos4ALL{
  _id: string,
  nombreProducto: string,
  fecha: number,
  link: string
}
export interface prodGenerico{
  idProducto?: string,
  fechaProducto?: number,
  idPlantilla?: string,
  secciones?: seccionProducto[],
  tipo?: number,
  completo?: number,
  idSurvey?:number,
  tokenConfig?:string,
}
export interface seccionProducto{
  _id: string,
  nombre: string,
  orden: number,
  visible: number,
  estatus: boolean
}
export interface infoProductos{
  productosCertificar: prodCert[],
  productosMedir: prodMed[],
  productosNorma35: prodNorma35[],
  productosPulseCheck: prodPulseCheck[],
  productosDocumentador: prodDocumentador[],
  productosFocusArea: prodFocusArea[],
  productosCultureAudit: prodCultureAudit[],
  productosCultureAuditV2: prodCultureAudit[],
  productosCultureAuditTR: prodCultureAudit[],
  productosMedir2: prodGenerico[],
  productosResultados: prodResultados[],
  productosResultados4all:productosResultados4all[],
  productosResultadosForallViejas:productosResultadosForallViejas[],
  productosResultadosSencillos4all: productosResultados4all[],
  productosResultadosGlobales: prodResultados[],
  productosResultadosCompletos: prodResultados[],
  productosResultadosSencillos4ALL: productosResultadosSencillos4ALL[],
  paquetes: prodPaquete[],
  productosResultados5cero: prodresults5[],
  productosCGOExpress: productosCGOExpress[],
}

export interface productosCGOExpress{
  companyId?: string,
  createdAt?: string,
  date?: number,
  launch?: boolean,
  nameProduct?: string,
  programming?: {launchDate: string, closeDate: string}
  reLaunch?: boolean,
  surveyToken?: string,
  updatedAt?: string,
  urlShorter?: string,
  version?: string,
  __v?: number,
  _id?: string,
}
export interface prodresults5{
  fecha: number,
  nombreProducto: string,
  tipo: number,
  _id: string,
}

//get idiomas fechas
export interface getIdiomaFechas{
  fechaCertificar?: number,
  fechaMedir?: number,
  fechaNorma35?: number,
  fechaPulseCheck?: number,
  fechaDocumentador?: number,
  fechaFocus?: number,
  productoId?: string
}
//get idiomas
export interface getIdiomaInd{
  _id?: string,
  tipoIdioma?: string,
  nombreIdioma?: string,
  vivoIdioma?: number,
  clave?: string,
  vivo?: number,
  createdAt?: string,
  updatedAt?: string,
}
export interface getIdiomas{
  idiomasMostrar?: getIdiomaInd[],
  idiomas?: getIdiomaInd[],
  arrayMostrar?: getIdiomaInd[],
}
///// interfaz guarda idioma
export interface nuevoIdioma{
  tipoIdioma:number,
  nombreIdioma:string,
  vivoIdioma:number,
  idProducto:string
}
// respuesta getstatus
export interface getStatusIndiv{
  estatus: number
}
// respuesta all statusAdi
export interface getAllStatus{
  message: string,
  nombre: string,
  estatusSecciones: {
    _id: string,
    idiomas: number,
    reactivos: number,
    confirmacion:number,
    colaboradores: number,
    encuesta: number,
    forall: number,
    demograficos: number,
    abiertas: number,
    adicionales: number,
    programacion: number,
    envio: number,
    close: number,
    nps: number,
    control:number,
    template:number,
    emailEdit:number,
    leaderSelect:number,
    avance:number,
    voice:number
  }
}
//get adicionales
export interface getAdicionales{
  message: string,
  adicionalesMostrar: getAdicional[]
}
export interface getAdicional{
  adicional: adicionalTraduccion[],
  _id: string,
  orden: number,
  vivoAdicional: number
}
export interface adicionalTraduccion{
  opciones: opcionAdicional[],
  _id: string,
  tipoPreguntaAdicionales: number,
  textoPregunta: string,
  idiomaAdicionales: string
}
export interface opcionAdicional{
  _id: string,
  ordenOpcion?: number,
  textoOpcion: string,
  vivoOpcion?: number
}
// interfaz guarda adicional
export interface nuevoAdicional{
  adicionalId?: string,
  fechaCertificar?: number,
  fechaMedir?: number,
  fechaPulseCheck?: number,
  fechaFocus?: number,
  tipoPreguntaAdicionales?: number,
  textoPregunta?: string,
  idiomaAdicionales?: string,
  orden?: number,
  empresaId?: string,
  tipoRespuesta?:number
  pregunta?: string,
  seccion?: number,
  requerido?: number,
}
export interface respuestaNuevoAdicional{
  message: string,
  idAdicionalExterna: string,
  idAdicionalInterna: string,
  orden: number
}
// interfaz modifica adicional
export interface modificaAdicional{
  fechaCertificar?: number,
  fechaMedir?: number,
  fechaPulseCheck?: number,
  fechaFocus?: number,
  arrayId: string,
  adicionalId?: string,
  textoPregunta?: string,
  vivoAdicional?: string,
  empresaId?: string,
}
export interface respuestaModifAdicional{
  message: string,
  id: string,
  textoPregunta?: string,
  vivoAdicional?: number
}
//interfaz guarda opcion a adicional
export interface nuevaOpcionAdicional{
  fechaCertificar?: number,
  fechaMedir?: number,
  fechaPulseCheck?: number,
  fechaFocus?: number,
  arrayId: string,
  adicionalId: string,
  textoOpcion?: string,
  ordenOpcion?: string,
  idOpcion?:string,
  vivoOpcion?:string
}
export interface respuestaNuevaOpcionAdicional{
  message: string,
  opcionMostrar: {
    _id: string,
    ordenOpcion: number,
    textoOpcion: string,
    vivoOpcion: number
  }
}
export interface respuestaModificaOpcionAdicional{
  message: string,
  opcionBuscada: {
    _id: string,
    ordenOpcion: number,
    textoOpcion: string,
    vivoOpcion: number
  }
}
//interfaz respuesta inserta traduccion a adicional
export interface respuestaTraduccionAdicional{
  message: string,
  idInterna: string
}
//interfaz lista de idiomas del backend
export interface listaIdiomasBack{
  idiomas: string[]
}
//interfaz respuesta al guardar un archivo del filemanager
export interface respuestaGuardaArchivo{
  archivoMostrar: archivoGuardado,
  message: string,
  status: boolean
}
//interfaz de get archivos de empresa
export interface getArchivosEmpresa{
  archivos: archivoGuardado[],
  empresa: string,
  message: string,
  status: boolean
}
//interfaz respuesta de get archivos instituto
export interface getArchivosInstituto{
  empresas: empresaArchivos[],
  success: boolean
}
export interface empresaArchivos{
  nombreEmpresa: string,
  archivos: archivoGuardado[]
}
//interfaz de archivo guardado
export interface archivoGuardado{
  fechaRegistro?: string,
  nombreArchivoCode?: string,
  rutaArchivo?: string,
  vivoArchivo?: string,
  _id?: string,
  tipoArchivo?: string,
}
//interfaz get tipos demograficos
export interface allDemograficos{
  message: string,
  demograficos: demograficoInd[]
}
export interface demograficoInd{  // a esta interfaz le hace falta mas atributos
  clave: string,
  _id: string,
  excel: number
}
///Interfaz para Guardar LOGO
export interface logoEmpresa{
  Success: boolean,
  message: string,
  message2: string,
  rutaArchivo: string
}
//Interfaz para Obtener logo
export interface getLogoEmpresa{
  message: string,
  rutaArchivo: string,
  success:boolean,
}

//Interfaz de respuesta de status modales
export interface getStatusModal {
  estatus: number,
  success: boolean
}
//interfaz de respuesta para secciones de certificar
export interface getSecciones{
  secciones: seccion[],
  success: boolean
}
export interface seccion{
  estatus: boolean,
  nombre: string,
  orden: number,
  _id: string
}
//interfaz de respuesta de info de centros de trabajo
export interface getInfoCentros{
  centros: centroFull[]
}
export interface centroFull{
  totalColaboradores:number,
  centro: centroInd,
  user: userCTInfo
}
export interface centroInd{
  actividad_principal_CT: string,
  domicilio_CT: string,
  email_razon_social?: string,
  email_responsable_CT: string,
  id_CT: number,
  nombre_CT: string,
  nombre_responsable_CT: string,
  productoId: string,
  _id: string
}
export interface userCTInfo{
  createdAt: string,
  empresaId: string,
  level: number,
  password: string,
  updatedAt: string,
  user: string,
  __v: number,
  _id: string,
}
//interfaz  de fechas Programacion de Encuestas  de PulseCheck
export interface getFechaPulse{
  data: fechaMesPulse[],
  message:string,

}
export interface fechaMesPulse{
  fechaLanzamiento: string,
  fechaCierre:string,
  numeroFecha: number,
  _id: string,
}

//Interfaz de respuesta de fechas de recordatorios para MEDIR
export interface getFechasMedir{
  success?: boolean,
  fechas: {
    fechaCierre: string,
    fechaLanzamiento: string,
    vivoProgramacion: number,
    _id: string,
    recordatorios: getRecordatorios[],
  }
}

export interface getRecordatorios{
  fechaRecordatorio: string,
  vivoRecordatorio: number,
  _id: string,
}
//Interfaz de respuesta de fechas de recordatorios para Focus
export interface getFechasFocus{
  success?: boolean,
  fechaCierre: string,
  fechaInicio: string,
  recordatorios: getRecordatoriosFocus[],

}
export interface getRecordatoriosFocus{
  fechaRecordatorio: string,
  vivoRecordatorio: number,
  _id: string,
}

//Interfaz de respuesta de fechas de recordatorios para Pulsecheck
export interface getFechasPulse{
  message?: string,
  data: getRecordatorios[],
}

export interface getRecordatorios{
  fechaRecordatorio: string,
  vivoRecordatorio: number,
  _id: string,
}

export interface getProgressEncPulse{
  data:  getProgressPulse[],
  message:string,

}
//Interfaz  de Progress de Encuestas  de PulseCheck
export interface getProgressPulse{
  endUsers: number,//0
  idSurvey: number,//155
  link: string,//"http://newsurvey.culturalgo.com/appsurvey/login/5viTQ5XYyR"
  numeroFecha: number,//1
  porcentaje: number,//0
  portalConteos: string,
  token: string,//"5viTQ5XYyR"
  totalUsers: number,//2
  userDemo: string,//"1158900"

}
//interfaz de respuesta de parametros de tableau
export interface getParamsTableau{
  brokerId: number,
  success: boolean,
  surveyToken?: string,
  user: string,
  userType: number,
  productoId: number,
}

//interfaz de respuesta de parametros de tableau para covid
export interface getParamsTableauCovid{
  idCompany: string,
  nameCompany: string,
  idBroker: number
}

//INTERFACE PARA TRADUCCIONES DE REACTIVOS
export interface respuestaTraducciones{
  message: string,
  arrayMostrar: traducciones[]
}
export interface traducciones{
  idiomaId: string,
  nombreIdioma: string,
  reactivos: reactivoTraduccion[]
}

export interface reactivoTraduccion{
  preguntaNativa: string,
  reactivoId: string,
  preguntaTraduccion: string
}

//INTERFACE PARA TRADUCCIONES DE ABIERTAS
export interface respuestaAbiertasTraducciones{
  message: string,
  arrayMostrar: traduccionesAbiertas[]
}
export interface traduccionesAbiertas{
  idiomaId: string,
  nombreIdioma: string,
  abiertas: reactivoabiertasTraduccion[]
}

export interface reactivoabiertasTraduccion{
  preguntaNativa: string,
  abiertaId: string,
  preguntaTraduccion: string
}

//INTERFACE PARA TRADUCCIONES DE NPS
export interface respuestaNpsTraducciones{
  message: string,
  arrayMostrar: traduccionesNps[]
}
export interface traduccionesNps{
  idiomaId: string,
  nombreIdioma: string,
  nps: reactivoNpsTraduccion[]
}

export interface reactivoNpsTraduccion{
  npsId: string,
  PreguntaNativa: string,
  preguntaTraduccion: string
}

//INTERFACE PARA TRADUCCIONES DE CONTROL
export interface respuestaControlTraducciones{
  message: string,
  arrayMostrar: traduccionesControl[]
}
export interface traduccionesControl{
  idiomaId: string,
  nombreIdioma: string,
  control: reactivoControlTraduccion[]
}

export interface reactivoControlTraduccion{
  controlId: string,
  PreguntaNativa: string,
  preguntaTraduccion: string
}


//INTERFACE PARA TRADUCCIONES DE DEMOGRAFICOS
export interface respuestaDemoTraducciones{
  message: string,
  arrayMostrar: traduccionesDemo[]
}
export interface traduccionesDemo{
  idiomaId: string,
  nombreIdioma: string,
  demograficos: demoabiertasTraduccion[]
}

export interface demoabiertasTraduccion{
  preguntaNativa: string,
  abiertaId: string,
  preguntaTraduccion: string,
  opciones: opcionesdemo[]
}

export interface opcionesdemo{
  ordenOpcion: number
  textoOpcion: string,
  traduccionOpcion: string
}

export interface portalConteos{
  message: string,
  avance: avanceConteos,
  completoCertificar:number,
  fechaLanzamiento: string,
  fechaCierre: string,

}
export interface avanceConteos{
  porcentaje: string,
  totalUsers: number,
  endUsers: number,
  url: string,
  url2: string,
  logoutUsers: number,
  respRecRes:number,
  respMinCer:number,
}
//Interface para el get de la info del TI
export interface getITInfo{
  success: boolean,
  datosTI: datosTI
}
export interface datosTI{
  nombreTI: string,
  emailTI: string,
  telTI: string,
  extTI: string,
  celTI: string
}
//interfaz para el get set de la modal de video de norma 35
export interface getN35modal{
  success: boolean,
  message: string,
  bandera: number
}
///service Filtros
export interface getListaFiltros{
  success: boolean,
  filtros: listaFiltros[]
}
export interface listaFiltros{
  id: number,
  nombre: string
}

export interface getConteosFiltros{
  success: boolean,
  resultado: resultadoConteos[]

}
export interface resultadoConteos{
  filtro: string,
  idSurvey:number,
  porcentaje: number,
  totalUsers: number,
  endUsers:number,
  logoutUsers?:number,
  usersGone?:number
}
export interface getEncuestasFocus{
  message:string,
  data: contenidoEncuestaFocus[]
}
export interface getEncuestasFocus3{
  data: contenidoEncuestaFocus3[]
}
export interface contenidoEncuestaFocus{
  fechaInicio:string,
  fechaCierre:   string,
  vivo: number,
  _id: string,
  empresaId: string,
  productoId: string,
  nombre: string,
  status: number,
  estatusVerificacion: number;
  idSurveyConfiguration?:any;
  // idiomas: idiomasFocus[],
  // preguntas: preguntasFocus[],
  createAT:  string,
  updateAt: string,
  statusEncuesta:boolean,
  //banderasEncuesta?:banderasEncuesta
}

export interface contenidoEncuestaFocus3{
  activo: boolean,
  completoCertificar: number,
  fechaCertificar: number,
  idCertificar: string,
  idPlantilla: string,
  idProducto: number,
  nameSurvey: string,
  nombrePlantilla: string,
  nombreProducto: string,
  numPulse: number,
  openSurvey: number,
  tipo: number,
  urlRT: string,
}

export interface banderasEncuesta{
  adicionalesBan?: boolean,
  likert31Ban?: boolean,
  reactivos: boolean,
  survey: boolean,
  users: boolean,
  usersApply: boolean,
  _id: string,
}
export interface encuestaPilotoFocus{
  message: boolean,
  data: encuestasPulse[],
}
export interface encuestasPulse{
  _id: string,
  idSurvey: number,
  fecha: string,
  userDemo: string,
  numeroFecha: number,
  urlShorter: string,
}
//interfaz para get de correos de resultados de cgo2
export interface getCorreosResuCGO2{
  success: boolean,
  numCorreos: number,
  correos: string[]
}

export interface arrayPosiciones{
  num: number
}

export interface CT_data{
  _id: string,
  descripcion: string,
  fechaCreacion: Date,
  fechaFin: Date,
  archivos: archivos_CT[],
  observaciones: string,
  apoyo: string,
  ruta: string,
  estatus: string
}

export interface archivos_CT{
  _id: string,
  nombreArchivo: string,
  rutaArchivo: string,
  vivoArchivo: string,
}
export interface  generarClave{
  message:string,
  clave:{
    _id: string,
    empresaId: string,
    productoId: string,
    claveProducto: number,
  }
}
export interface  getClaveConteos{
  success: boolean,
  message: string,
  clave:{
    _id: string,
    empresaId: string,
    productoId: string,
    claveProducto: number,
  }
}
export interface getConteosClave{
  message:string,
  clave:{
    _id: string,
    empresaId: string,
    productoId: string,
    claveProducto: number,
    _v:number,
    createdAt: string,
    updatedAt: string,
    encuestaId?:string;
  }
  avance:{
    porcentaje: string,
    totalUsers: number,
    endUsers: number,
    respRecRes:number,
    respMinCer:number,
  }
  empresa:string,
  lanzamiento: string,
  cierre: string,
  instituto: number,
  idProducto: string,
  resultsBoxEntregables: boolean,
  resultsBoxRanking: boolean,



}
export interface getClaveConteosPulse{
  success: boolean,
  message: string,
  claves: clavesPulse[],
}
export interface clavesPulse{
  _id: string,
  empresaId:string,
  productoId: string,
  claveProducto: number,
  idSurvey: number,
  __v: number,
}
export interface getPreguntasAdiocnalesFocus{
  success: boolean,
  message: string,
  caritas: number,
  claveNativo: string,
  idNativo: string,
  preguntas: preguntasAdicionalesFocus[],
  idiomaAdicional:IdiomasAdicionales[],
}
export interface IdiomasAdicionales{
  claveAdicional: string,
  idAdicional: string,
  length?:number,
}
export interface preguntasAdicionalesFocus{
  tipoAgregado: number,
  vivo: number,
  opciones: opcionesPreguntasFocus[],
  traducciones: traduccionesPreguntasFocus[],
  _id: string,
  tipoRespuesta: number,
  seccion: number,
  orden: number,
  plantillaId?: string,
  pregunta: string,
  requerido: number,
  createdAt: string,
  updatedAt: string,
  tipo?:number,

}
export interface opcionesPreguntasFocus{
  vivo: number,
  _id: string,
  respuesta: string,
  id: string,
  createdAt: string,
  updatedAt: string,
}
export interface traduccionesPreguntasFocus{
  _id: string,
}

export interface nuevoAdicionalFocus{
  empresaId : string,
  tipoRespuesta : number,
  seccion : number,
  orden : number,
  pregunta : string,
  requerido : number,
  idiomaId?: string,
  preguntaId?: string
  plantillaId?: string;
  tipo?: number;

}
export interface modificarAdicionalFocus{
  preguntaId: string,
  pregunta: string,
  empresaId?: string,
}

export interface agregarPreguntaAdicional{
  success: boolean,
  message: string,
  preguntaMostrar:{
    tipoAgregado: number,
    vivo: number,
    _id: string,
    tipoRespuesta: number,
    seccion: number,
    orden: number,
    pregunta: string,
    requerido: number,
    opciones: opcionesPreguntasFocus[],
    traducciones: traduccionesPreguntasFocus[],
  }
}
export interface modificarPreguntaAdicionalFocus{
  success: boolean,
  message: string,
  pregunta: string,
}
export interface nuevaOpcionAdicionalFocus{
  empresaId: string,
  preguntaId: string,
  orden : string,
  respuesta : string,
  idiomaId?: string,
  ordenOpcion?: number
}
export interface modificarOpcionAdicionalFocus{
  empresaId?: string,
  preguntaId : string,
  opcionId : string,
  respuesta : string,

}
export interface respuestaBorrarPreguntaAdicional{
  success: boolean,
  message: string,
  pregunta:{
    tipoAgregado: number
    vivo: number
    opciones: opcionesPreguntasFocus[],
    traducciones: traduccionesPreguntasFocus[],
    _id: string,
    tipoRespuesta: number,
    seccion: number,
    orden: number,
    pregunta: string,
    requerido: number,
    createdAt: string,
    updatedAt: string,
  }
}
//interfaz de respuesta de get status encuesta
export interface getEstatusEncuesta{
  success: boolean,
  adicionales: boolean,
  abiertas: boolean,
  control: boolean,
  demograficos: boolean,
  forall: boolean,
  nps: boolean,
  reactivos: boolean,
  survey: boolean,
  usersApply: boolean,
  users: boolean,
}
//interfaz de respuesta respuestaBorrarOpcionPreguntaAdicional FosuAresa

export interface respuestaBorrarOpcionPreguntaAdicional{
  success: boolean,
  message: string,
  opciones: opcionesPreguntasFocus[],
}
//interfaz de respuesta TraduccionesPreguntasAdicionales  FosuAresa
export interface respuestaTraduccionesPreguntasAdicionalesFocus{
  succes: boolean,
  arrayMostrar:  mostrarTraducionesAdicionalesFocus[],

}

export interface mostrarTraducionesAdicionalesFocus{
  clave: string,
  idiomaId: string,
  preguntas: preguntasTraduccionesAdicionalesFocus[],
  length:number,

}
export interface preguntasTraduccionesAdicionalesFocus{
  orden: number,
  tipoRespuesta: number,
  seccion: number,
  requerido: number,
  tipoAgregado: number,
  pregunta: string,
  _id: string,
  traduccion: string,
  opciones: opcionesTraduccionesAdicionalesFocus[],
  length:number;

}
export interface opcionesTraduccionesAdicionalesFocus{
  _id: string,
  orden: number,
  respuesta: string,
  traduccion: string
}
//interfaz de respuesta al guardar la url del autologin de encuesta
export interface getPilotoN35{
  success: boolean,
  urlMas50: string,
  userRandomMas50: string,
  urlMenos50: string,
  userRandomMenos50: string,
  urlCorta: string,
  message?: string
  usuariosTest: usuarioDemo[],
}

export interface consultarEncuesta{
  succes:boolean,
  resultado:resultadoEncuesta[]

}

export interface resultadoEncuesta{
  nombreEmpresa: string,
  sector: string,
  subSector: string;
  fechaCreacion: string,
  token?:string,
  encuestas:encuestaResultado[]

}

export interface encuestaResultado{
  tipoEncuesta: string,
  token: string,
  idSurvey: number,
  anio: number,
  correosEnviados: boolean,
  fechaAplicacion: string,
  fechaCierre: string,
  totalUsuarios: number,
  totalRespuestas: number
}

//interfaz de respuesta al consultar status de requerimientos
export interface statusReqTec{
  success: boolean,
  message: string,
  requerimientos: boolean,
  requerimientosv3: requerimientosv3,
  logo: boolean
}
export interface requerimientosv3{
  autentication: boolean,
  requirements: boolean,
  testAccess: boolean,
  testEmail: boolean,
  validationQ: boolean,
  _id: string
}
//interfaz de respueta de get url de culture audit v2
export interface getURLCA2{
  success: boolean,
  urlCA: {
    correo: string,
    url: string
  }
}

export interface timeLineGraficaCertificar{
  success: boolean,
  resultado: resultadoGrafica[],

}
export interface  resultadoGrafica{
  fecha: string,
  endUsers: number,
}
export interface surveyprogress {
  success: boolean,
  avance: avance[],
  fechaLanzamiento: string,
  fechaCierre: string
}


export interface avance{
  porcentaje: string,
  totalUsers: number,
  endUsers: number,
  logoutUsers: number,
  usersGone?:number,
  url: string,
  url2: string
}
export interface infoGrupoFocusArea{
  message: boolean,
  data: {
    vivo: number,
    _id: string,
    encuestaId: string,
    nombre: string,
    descripcion: string,
  }
}

export interface GruposFocusAreaAll{
  message: boolean,
  data: dataGruposFocus[],
}

export interface dataGruposFocus{

  vivo: number,
  _id: string,
  encuestaId: string,
  nombre: string,
  descripcion: string,

}
//////Focus area
export interface getFiltrosGruposFocusAreaAll{
  message: boolean,
  resultado: filtrosGruposFocus[],
}
export interface filtrosGruposFocus{
  id: number,
  nombre: string,
  subfiltros: subFiltrosGrupos[],
}
export interface subFiltrosGrupos{

}


////Descarga EXCEL}
export interface getFullInfoExcel{
  success: boolean,
  array: filtrosFullExcel[],
}
export interface filtrosFullExcel{
  key: string,
  filtros: filtrosInfoFullExcel[],
}
export interface filtrosInfoFullExcel{
  subfiltro: string,
  totalUsers: number,
  endUsers: number,
  porcentaje: string,
}
//interfaz de respuesta del get feedback
export interface getFeedback{
  success: boolean,
  message?: string,
  error?: string,
  feedback?: {
    correo: string,
    url: string
  }
}
export interface Resultados4all{

  success: boolean,
  resultado: resultado4all[],
  totalConocimiento: number,
  totalSatisfaccion: number,
  resultado2: resultadoDemografico[],
}
export interface resultado4all{
  practica: string,
  conocimiento: number,
  satisfaccion: number

}
export interface resultadoDemografico{
  demograficoId:number;
  demografico: string,
  segmentos: segmentosDemograficos[],
}
export interface segmentosDemograficos{
  segmento: string,
  conocimiento: number,
  satisfaccion: number,
}
export interface correosData{
  success: boolean,
  recordatoriosManuales: RecordatoriosManuales[]
}

export interface RecordatoriosManuales{
  id: string,
  fechaRecordatorio: Date,
  vivoRecordatorio: number
}

export interface getListaEmpresas{
  success: true
  data: {
    docs?: datosEmpresa[],
    totalDocs?: number,
    limit?: number,
    totalPages?: number,
    page?: number,
    pagingCounter?: number,
    hasPrevPage?: boolean,
    hasNextPage?: boolean,
    prevPage?: number,
    nextPage?: number
  }
}
export interface datosEmpresa{
  _id: string,
  datosEmpresa: {
    nombreEmpresa: string
  }
}
//interfaz carpeta unica
export interface carpetaGet{
  carpetaId?: string,
  _id: string,
  empresaId: {
    _id: string,
    datosEmpresa:{
      nombreEmpresa: string
    }
  }
  nombre: string,
  nombreArchivoCode?: string,
  ubicacion: string,
  createdAt: string,
  updatedAt: string,
  __v: number,
  itbm?: boolean,
  tipoArchivo?: string
}
//interfaz archivo unico
export interface archivoGet{
  tipoArchivo?: string,
  carpetaId?: string,
  _id: string,
  nombre: string,
  nombreArchivoCode?: string,
  ubicacion: string,
  tamanio: string,
  tipo: string,
  createdAt: string,
  updatedAt: string,
  __v: number
}

//interfaz respuesta guardar carpeta
export interface guardaCarpeta{
  success: boolean,
  message?: string,
  carpeta: carpetaGet
}
//interfaz respuesta guardar archivo
export interface guardaArchivo{
  success: boolean,
  message?: string,
  archivo: archivoGet
}
//interfaz get carpeta raiz
export interface getCarpetaRaiz{
  success: boolean,
  carpetas: carpetaGet[],
  archivos: archivoGet[]
}
//interfaz get carpeta
export interface getCarpetaInterna{
  success: boolean,
  carpeta: carpetaGet,
  subcarpetas: carpetaGet[],
  archivos: archivoGet[]
}
///interface encuesta piloto  respuesta
export interface getEncuestaPilotoC2{
  message: string,
  piloto:{
    url: string,
    url2: string,
    usuariosTest: usuarioDemo[],
  }
}

export interface usuarioDemo{
  _id: string,
  name: string,
  password: string
  typeUser: number
}
//interfaz get pasos requerimientos tecnicos
export interface getInfoReqTec{
  message: string,
  pasos: pasoReqTec[]
}
export interface pasoReqTec{
  _id: string,
  empresa: string,
  paso: number,
  status: number,
  comentarios: comentarioReqTec[],
  __v: number,
}
export interface comentarioReqTec{
  _id: string,
  texto: string,
  fecha: string
}

export interface allColaboradoresAyuda{
  success: boolean,
  resultado: resultado[]
}
export interface resultado{
  BrokerID: string,
  HierarchicalPath: string,
  IdUser: number,
  Institute: number,
  NameUser: string,
  NeedHelp: number, // 0 no 1 es que sí
  RowID: number,
  SecciónI?: number,
  SecciónII?: number,
  SecciónIII?: number,
  SecciónIV?: number,
  surveyToken: string
}

export interface getEncuestasActivas{
  companies:  encuestasActivas[],
  success: boolean,
  totalEmpresas: number,
}
export interface encuestasActivas{
  count_id_status_user: number,
  CompanyName: number,
  Institute: number,
  ProductId: number,
  ProductName: number,
  id_survey_configuration: number,
  Status: string,
  SurveyRespondent: string,
  UserTotals: number,
  token:string,
}

export interface centrosDeTrabajo{
  bdcentrosTrabajo: bdCentrosTrabajo [],
  columnas: [],
  message: string
}

export interface bdCentrosTrabajo{
  actividad_principal_CT: string,
  domicilio_CT: string,
  email_responsable_CT: string,
  id_CT: string,
  nombre_CT: string,
  nombre_responsable_CT: string,
  productoId: string,
  _id: string
}

export interface GeneralesCentrosDeTrabajo{
  actividadPrincipal: string,
  actividades: string,
  arrayAyuda:[],
  arrayNoAcept:[],
  ayuda: number,
  centroTrabajo: string,
  domicilio: string,
  empresa: string,
  fechaAplicacion: string,
  hombres: number,
  mujeres: number,
  noAcept: number,
  objetivo: string,
  sufrieron:[],
  totalColaboradores: number,
  totalEncuestados: number
}

export interface sufrieron{
  NameUser:string
}

export interface arrayNoAcept{
  name:string
}

export interface arrayAyuda{
  NameUser:string
}

export interface respuestasEncuesta{
  result:ResultadoEncuesta [],
  success: boolean
}

export interface ResultadoEncuesta{
  BrokerID: number,
  Institute: number,
  NumStatementResult: number,
  ResponseValueNO: number,
  ResponseValueYES: number,
  RowID: number,
  StatementName: string,
  statementtype: number,
  surveytoken: string
}

export interface respuestasFactores{
  result:ResultadoFactores [],
  success: boolean
}

export interface ResultadoFactores{
  BrokerID: number,
  Institute: number,
  NumStatementResult: number,
  ResponseValueAlmostNever: number,
  ResponseValueAlways: number,
  ResponseValueNever: number,
  ResponseValueSometimes: number,
  ResponseValueUsually: number,
  RowID: number,
  StatementName: string,
  statementtype: number,
  surveytoken: string
}

export interface tableroGlobal{
  categorias: Categorias[],
  colaboradores:Colaboradores[],
  dimensiones: Dimensiones[] ,
  dominios: Dominios[],
  total: Total[],
}

export interface Colaboradores{
  fullName: string,
  _id:string
}

export interface Categorias{
  BrokerID: number,
  DimensionOrCategoryID: number,
  DimensionOrCategoryName: string,
  IdType: number,
  Institute: number,
  RowID: number,
  Type: string,
  surveyToken: string,
  valorColor:number,
  value: string
}

export interface Dominios{
  BrokerID: number,
  DimensionOrCategoryID: number,
  DimensionOrCategoryName: string,
  IdType: number,
  Institute: number,
  RowID: number,
  Type: string,
  surveyToken: string,
  valorColor:number,
  value: string
}

export interface Dimensiones{
  BrokerID: number,
  DimensionOrCategoryID: number,
  DimensionOrCategoryName: string,
  IdType: number,
  Institute: number,
  RowID: number,
  Type: string,
  surveyToken: string,
  valorColor:number,
  value: string
}

export interface Total{
  BrokerID: number,
  DimensionOrCategoryID: number,
  DimensionOrCategoryName: string,
  IdType: number,
  Institute: number,
  RowID: number,
  Type: string,
  surveyToken: string,
  valorColor:number,
  value: string
}


////focus Bandera encuesta//7
export interface actualizaBanderaFocus{
  estatusVerificacion: number;
  success: boolean
}
//
// export interface getPreguntasReactivosPlantillas{
//   caritas: number,
// claveNativo: string,
// idNativo: string,
// idiomaAdicional?: IdiomaReactivosAdicionalPlantillas[],
// message: string,
// preguntas: preguntasReactivosPlantillas [],
// success: boolean,
//
// }
//
// export interface preguntasReactivosPlantillas {
// createdAt: string;
// opciones:opcionesPreguntas[],
// orden: number,
// plantillaId: string,
// pregunta: string,
// requerido: number,
// seccion: number,
// tipoAgregado: number,
// tipoRespuesta: number,
// traducciones: traduccionPreguntas[],
// updatedAt: string,
// vivo: number,
// _id: string,
// }

export interface getEncuesta{
  abiertas: abiertas[],
  control: control[],
  demograficos: demograficos[],
  forall: forall[],
  instrucciones:string,
  nps: nps[],
  perspectivaGrup:string,
  perspectivaOrg:string,
  reactivos: reactivos[],
  respuestasReactivos: respuestasReactivos[],
  success:boolean
}

export interface abiertas{
  pregunta: string,
}

export interface control{
  pregunta: string,
  respuestas:respuestasControl[]
}

export interface respuestasControl{
  id:number,
  respuesta: string,
  value:string
}

export interface demograficos{
  pregunta: string,
  respuestas:respuestasDemograficos[]
}

export interface respuestasDemograficos{
  ordenOpcion: number,
  textoOpcion: string,
  vivoOpcion: number,
  _id: string
}

export interface forall{
  pregunta: string,
}

export interface nps{
  pregunta: string,
}

export interface reactivos{
  pregunta: string,
}

export interface respuestasReactivos{
  orden:number,
  respuesta: string,
  value:string
}

export interface actualizarCA{
  message:string,
  success: boolean
}

export interface ConsultarEncuestaNorma35{
  array:EncuestaNorma35[],
  instrucciones: string,
  success: boolean
}

export interface EncuestaNorma35{
  descripcion:string,
  nombre: string,
  preguntas: PreguntasNorma35[]
}

export interface PreguntasNorma35{
  clave: string,
  id: number,
  orden: number,
  pregunta: string,
  requerido: number,
  respuestas: RespuestasNorma35[],
  seccion: number,
  tipoRespuesta: number
}

export interface RespuestasNorma35{
  id: number,
  respuesta: string,
  value: string
}

export interface surveyCheck{
  success: boolean,
  result: {
    docs: docsCheck[],
    hasNextPage: boolean,
    hasPrevPage: boolean,
    limit: number,
    nextPage: any;
    page: number,
    pagingCounter: number,
    prevPage: any;
    totalDocs:number,
    totalPages: number,
  }
}

export interface docsCheck{
  email: string,
  fullName: string,
  surveyKey?: string,
  _id: string,
  age?:any,
  ownKey?:any
}

export interface resultExcel{
  success: boolean,
  result: resultExcelCol[]

}

export interface resultExcelCol{
  email?: string,
  end_date: string,
  id_status: any
  name?: string,
  start_date: string
}

export interface Muestras{
  muestras: muestrasAuditoria[],
  success: boolean
}

export interface muestrasAuditoria{
  colaboradores: colaboradoresAuditoria[],
  createdAt: string,
  nombre: string,
  productoId: string,
  updatedAt: string,
  __v: number,
  _id: string
}

export interface colaboradoresAuditoria{
  cellphone: string,
  comment_auditoria: string,
  email: string,
  end_date: string,
  fullName: string,
  phone: string,
  start_date: string,
  _id: string
}

export interface comentarioAuditoria{
  message: string,
  success: boolean
}

export interface respuestaAgregarUsuariosAuditoria{
  message: string,
  success: boolean
}

export interface CultureAuditVersion2{
  link: string,
  success:boolean
}

export interface updateFechaCierre{
  productoId:string,
  empresaId: string,
  fecha:any,

}

export interface portalConteosV2{
  result: filtrosPortalConteosV2[],
  success: boolean
}

export interface portalConteosV2Reducido{
  result: filtrosPortalConteosV2Reducido[],
  success: boolean
}

export interface sincronizacionPortalConteos{
  message: string,
  numeroErrores: number,
  success: boolean
}

export interface surveyCheck{
  success: boolean,
  result: {
    docs: docsCheck[],
    hasNextPage: boolean,
    hasPrevPage: boolean,
    limit: number,
    nextPage: any;
    page: number,
    pagingCounter: number,
    prevPage: any;
    totalDocs:number,
    totalPages: number,
  }
}

export interface docsCheck{
  email: string,
  fullName: string,
  surveyKey?: string,
  _id: string,
  age?:any,
  ownKey?:any
}

export interface filtrosPortalConteosV2{
  COLABORADORES_QUE_AUN_NO_RESPONDEN: number,
  COLABORADORES_QUE_YA_RESPONDIERON: number,
  FILTRO: string,
  Nivel_1: string,
  Nivel_2: string,
  PROGRESO_TOTAL: number,
  SEGMENTO: string,
  TOTAL_DE_COLABORADORES: number
}

export interface filtrosPortalConteosV2Reducido{
  COLABORADORES_QUE_AUN_NO_RESPONDEN: number,
  COLABORADORES_QUE_YA_RESPONDIERON: number,
  FILTRO: string,
  PROGRESO_TOTAL: number,
  SEGMENTO: string,
  TOTAL_DE_COLABORADORES: number,
  visible:boolean,
}

export interface consultarRT{
  succes:boolean,
  productos:productosResultadoRT[]

}

export interface productosResultadoRT{
  certificar: {
    fechaCertificar: number,
    idProducto: number,
    idSurveyConfiguration: number,
    requerimientosv3: {
      autentication: boolean,
      requirements: boolean,
      testAccess: boolean,
      testEmail: boolean,
      validationQ: boolean,
      _id: string
    },
    tokenConfig: string,
    _id: string
  },
  createdAt: string,
  datosEmpresa: {
    institutoEmpresa:number,
    nombreEmpresa: string
  },
  _id: string
}

export const CLAVES_COLUMNASPRODUCTOS = [
  'name',
  'email',
  'id_status',
  'start_date',
  'end_date',
];
export const CLAVES_COLUMNASLEADERS = [
  'NameUser',
  'email',
  'Area',
  'JobTitle',
  'Localidad',
  'NumberOfEmails',
  'IdUser',
  'MailDeliveryStatus',
  'Pass_cgo',
  'SurveyID',
  'User_cgo',
  'keyUserlogin',
  'native',
];

export const CLAVES_COLUMNASAUDITORIA = [
  'HierarchicalPath',
  'RespondentCount',
  'Time_DeviationCount',
  'Time_DeviationPercentage',
  'ControlStatement_DeviationCount',
  'ControlStatement_DeviationPercentage',
  'RandomStatement_DeviationPercentage',
  'RandomStatement_DeviationCount',
];

export const CLAVES_COLUMNASNORMA = [
  'email',
  'end_date',
  'id_status',
  'start_date'
];

export const CLAVES_COLUMNASEMAILGRAL = [
  'name',
  'email',
  'status'
];

export const ExcelresultsMas50 = [
  'Ambiente de trabajo',
  'Ambiente de trabajo_COLOR',
  'CARGO O FUNCIÓN EN EL CENTRO DE TRABAJO',
  'CARGO O FUNCIÓN HOMOLOGADO',
  'Carga de trabajo',
  'Carga de trabajo_COLOR',
  'Condiciones en el ambiente de trabajo',
  'Condiciones en el ambiente de trabajo_COLOR',
  'Entorno organizacional',
  'Entorno organizacional_COLOR',
  'Factores propios de la actividad',
  'Factores propios de la actividad_COLOR',
  'Falta de control sobre el trabajo',
  'Falta de control sobre el trabajo_COLOR',
  'GRADO ACADÉMICO',
  'GÉNERO',
  'Insuficiente sentido de pertenencia e, inestabilid',
  'Insuficiente sentido de pertenencia e, inestabilid_COLOR',
  'Interferencia en la relación trabajo-familia',
  'Interferencia en la relación trabajo-familia_COLOR',
  'Jornada de trabajo',
  'Jornada de trabajo_COLOR',
  'Liderazgo',
  'Liderazgo y relaciones en el trabajo',
  'Liderazgo y relaciones en el trabajo_COLOR',
  'Liderazgo_COLOR',
  'NOMBRE DEL COLABORADOR',
  'NivelEstructural_1',
  'NivelEstructural_2',
  'NivelEstructural_3',
  'NivelEstructural_4',
  'NivelEstructural_5',
  'NivelEstructural_6' ,
  'NivelEstructural_7',
  'NivelEstructural_8',
  'NivelEstructural_9',
  'NivelEstructural_10',
  'NivelGeográfico_1',
  'NivelGeográfico_2',
  'NivelGeográfico_3',
  'NivelGeográfico_4',
  'NivelGeográfico_5',
  'Organización del tiempo de trabajo',
  'Organización del tiempo de trabajo_COLOR',
  'Reconocimiento del desempeño',
  'Reconocimiento del desempeño_COLOR',
  'Relaciones en el trabajo',
  'Relaciones en el trabajo_COLOR',
  'Violencia',
  'Violencia_COLOR',
]
export const ExcelResultMas501 =[
  'NOMBRE DEL COLABORADOR',
  'NivelGeográfico_1',
  'NivelGeográfico_2',
  'NivelGeográfico_3',
  'NivelGeográfico_4',
  'NivelGeográfico_5',
  'NivelEstructural_1',
  'NivelEstructural_2',
  'NivelEstructural_3',
  'NivelEstructural_4',
  'NivelEstructural_5',
  'NivelEstructural_6',
  'NivelEstructural_7',
  'NivelEstructural_8',
  'NivelEstructural_9',
  'NivelEstructural_10',
  'CARGO O FUNCIÓN EN EL CENTRO DE TRABAJO',
  'CARGO O FUNCIÓN HOMOLOGADO',
  'GÉNERO',
  'GRADO ACADÉMICO',
  'Condiciones en el ambiente de trabajo',
  'Ambiente de trabajo',
  'Carga de trabajo',
  'Falta de control sobre el trabajo',
  'Factores propios de la actividad',
  'Jornada de trabajo',
  'Interferencia en la relación trabajo-familia',
  'Organización del tiempo de trabajo',
  'Liderazgo',
  'Relaciones en el trabajo',
  'Violencia',
  'Liderazgo y relaciones en el trabajo',
  'Reconocimiento del desempeño',
  'Insuficiente sentido de pertenencia e, inestabilid',
  'Entorno organizacional',
]

export const ExcelResultMenos50 =[
  'NOMBRE DEL COLABORADOR',
  'NivelGeográfico_1',
  'NivelGeográfico_2',
  'NivelGeográfico_3',
  'NivelGeográfico_5',
  'NivelEstructural_1',
  'NivelEstructural_2',
  'NivelEstructural_3',
  'NivelEstructural_4',
  'NivelEstructural_5',
  'NivelEstructural_6',
  'NivelEstructural_7',
  'NivelEstructural_8',
  'NivelEstructural_9',
  'NivelEstructural_10',
  'CARGO O FUNCIÓN EN EL CENTRO DE TRABAJO',
  'CARGO O FUNCIÓN HOMOLOGADO',
  'GÉNERO',
  'GRADO ACADÉMICO',
  'Condiciones en el ambiente de trabajo',
  'Ambiente de trabajo',
  'Carga de trabajo',
  'Falta de control sobre el trabajo',
  'Factores propios de la actividad',
  'Jornada de trabajo',
  'Interferencia en la relación trabajo-familia',
  'Organización del tiempo de trabajo',
  'Liderazgo',
  'Relaciones en el trabajo',
  'Violencia',
  'Liderazgo y relaciones en el trabajo'
]

export const CLAVES_COLUMNASCONSULENCUES = [
  'Survey Token',
  'Nombre de la empresa',
  'NOMBRE DE PUBLICACION PARA LISTA',
  'País de la Empresa',
  'Certificate Date',
  'Sector',
  'Tipo Encuesta',
  'Survey Start',
  'Survey End',
  'ID Acount',
  'ID Oportunity',
  'Año Ranking',
  'COMPAÑERISMO',
  'CREDIBILIDAD',
  'Categoría Ranking',
  'Confianza ',
  'Es Multinacional?',
  'GRUPO MULTINACIONAL AL QUE PERTENECE',
  'Gestalt',
  'IMPARCIALIDAD',
  'Innovación por Todos ',
  'Liderazgo Efectivo ',
  'Liderazgo en Movimiento ',
  'Maximizar CAST(Potencial Humano ',
  'ORGULLO',
  'PAIS (LEAD AFFILIATE)',
  'PROMEDIO AREA',
  'PROMEDIO EMPRESA',
  'PROMEDIO TI',
  'REGIÓN',
  'RESPETO',
  'Propietario Cuenta',
  'Total CA (AVG)',
  'Total CA (SUMA)',
  'Valores ',
  '¿Cuál es tu nivel de confianza en las capacidades de los directores de tu empresa? APLICO (SI / NO)',
  'En los últimos 12 meses, ¿cuántas oportunidades has tenido para desarrollar, innovar o crear nuevas o mejores formas de',
  ' # RESPUESTAS ESTUDIOS',
  ' Cargo o función homologado US APLICO (SI / NO)',
  ' Edad US APLICO (SI / NO)',
  ' Generación US APLICO (SI / NO)',
  ' Género APLICO (SI / NO)',
  ' Situación laboral US APLICO (SI / NO)',
  '# HC',
  ' Antigüedad US APLICO (SI / NO)',
  'CGo_Process_DBDeliveredByClient_NumUsers',
  'Total Percent30',
];
